import { maunaRewardAPI } from '@/api';
import CommonSpaceListContainer from '@/components/common/CommonSpaceListContainer';
import MaunaHeader from './MaunaHeader';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';

interface RewardDataType {
  id: number;
  title: string;
  category: number;
  description: string;
  img: string | null;
  sid: number | null;
  adminCode: string | null;
  createdAt: string;
  updatedAt: string;
}

const columnHelper = createColumnHelper<RewardDataType>();

const categoryMap: Record<number, string> = {
  1: '커피',
  2: '시설이용 할인권',
  3: '굿즈',
};

const decodeAdminCode = (value?: string | null) => {
  if (!value) return '';

  try {
    const binary = window.atob(value);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    const decoded = new TextDecoder().decode(bytes);

    return decoded.includes('\uFFFD') ? value : decoded;
  } catch {
    return value;
  }
};

const getColumns = (): ColumnDef<RewardDataType, unknown>[] => {
  const baseColumns = [
    columnHelper.accessor('id', {
      header: 'ID',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('title', {
      header: '리워드명',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('category', {
      header: '카테고리',
      cell: (info) => categoryMap[info.getValue()] || info.getValue(),
    }),
    columnHelper.accessor('sid', {
      header: '공간 ID',
      cell: (info) => info.getValue() ?? '-',
    }),
    columnHelper.accessor('adminCode', {
      header: '승인코드',
      cell: (info) => decodeAdminCode(info.getValue()),
    }),
    columnHelper.accessor('description', {
      header: '설명',
      cell: (info) => {
        const text = info.getValue() || '';
        const truncated = text.length > 20 ? `${text.slice(0, 20)}...` : text;
        return <span title={text}>{truncated}</span>;
      },
    }),
    columnHelper.accessor('updatedAt', {
      header: '수정일',
      cell: (info) => new Date(info.getValue()).toLocaleDateString(),
    }),
  ];

  return baseColumns.filter(Boolean) as ColumnDef<RewardDataType, unknown>[];
};

const MaunaRewardContainer = () => {
  return (
    <CommonSpaceListContainer<RewardDataType>
      HeaderComponent={MaunaHeader}
      queryKey="getRewardsMaunaAdmin"
      queryFn={() =>
        maunaRewardAPI.getRewards({
          code: import.meta.env.VITE_SECRET_API_KEY,
        })
      }
      columns={getColumns}
      baseRoute="/mauna/reward"
      buttonColor="resom"
      showCreateButton={false}
    />
  );
};

export default MaunaRewardContainer;
